var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:[
    { root: true, chatOpen: _vm.chatOpen, sidebarClose: _vm.sidebarClose, sidebarStatic: _vm.sidebarStatic },
    _vm.dashboardThemeClass,
    'sing-dashboard',
  ]},[_c('Sidebar'),_c('div',{staticClass:"wrap"},[_c('Header'),_c('div',{staticClass:"content"},[_c('transition',{attrs:{"name":"router-animation"}},[_c('router-view')],1),_c('footer',{staticClass:"contentFooter"},[_c('small',[_vm._v("Goaltip GmbH - v."+_vm._s(_vm.version))])])],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }